/* blocks */
import EventDetails from './components/EventDetails/EventDetails'
import EventVenueDetails from './components/EventVenueDetails/EventVenueDetails'
import Portfolio from '../VideoMarketing/components/Portfolio/Portfolio'
import IndividualEventsPageHero from './components/IndividualEventsPageHero/IndividualEventsPageHero'
import SimilarEvents from './components/SimilarEvents/SimilarEvents'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import {
  IndividualEventsPageAttributes,
  SimilarEventsPageAttributes
} from '@/utils/queries/individual-events-page'

interface Props {
  data: IndividualEventsPageAttributes
  similarEvents: SimilarEventsPageAttributes[]
}

function EventsIndividualPages({ data, similarEvents }: Props) {
  return (
    <>
      <IndividualEventsPageHero
        heroImage={data.heroImage}
        tag={data.tag}
        eventTitle={data.eventTitle}
        eventDescription={data.eventDescription}
        eventType={data.eventType}
        eventId={data.eventId}
        venue={data.venue}
        heroBgColor={data.heroBgColor}
        startTime={data.startTime}
        endTime={data.endTime}
        eventDate={data.eventDate}
        eventDuration={data.eventDuration}
        slug={data.slug}
        thankYouMessage={data.thankYouMessage}
        recordingUrl={data.recordingUrl}
      />

      {data.speakerDetails.length > 0 ? (
        <EventDetails
          aboutSession={data.aboutSession}
          takeaways={data.takeaways}
          speakersList={data.speakerDetails}
        />
      ) : null}

      {data.venueMapLink && data.venueIframeLink ? (
        <EventVenueDetails
          venueAddress={data.venueAddress}
          venueMapLink={data.venueMapLink}
          venueIframeLink={data.venueIframeLink}
        />
      ) : null}

      {data.galleryList.length > 0 ? (
        <Portfolio
          title={data.galleryTitle}
          titleClass="text-2xl lg:text-3xl font-semibold text-white"
          lists={data.galleryList.map(i => ({
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            videoUrl: i.multimedia?.url ?? ''
          }))}
        />
      ) : null}

      {similarEvents.length > 0 ? (
        <SimilarEvents title="Discover Related Events" lists={similarEvents} />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
          mode="full_width"
          variant="dark"
        />
      ) : null}
    </>
  )
}

export default EventsIndividualPages
